import { useRoute } from '@monorepo/tools/src/lib/hooks/tools/use-route';
import { IAdminxStore } from '../../../modules/stores';
import { usePageSettings } from '@monorepo/tools/src/lib/hooks/tools/use-page-settings';
import { useStateBetweenPages } from '../../../modules/hooks/tools/use-state-between-pages';
import { useStores } from '@monorepo/controlled/src/hooks/use-stores';
import { observer } from 'mobx-react';
import { BidderAdvertiserTableModel } from '../../../modules/models/bidder-advertiser.model';
import { useList } from '../../../modules/hooks/tools/use-list';
import { sortData } from '../../../modules/hooks/tools/use-merge-with-performance';
import { Pagebar, PagebarTitle } from '@monorepo/base/src/components/page/pagebar/pagebar';
import { Page } from '@monorepo/base/src/components/page/page';
import { ControlledTable } from '@monorepo/controlled/src/components/table-wrapper/table-wrapper';
import routes from '../../../modules/routes/index.routes';
import { useBidderAdvertiserActions } from '../../../modules/hooks/actions/bidder-advertiser.actions';
import { useBidderAdvertisersHeaders } from '../../../modules/hooks/theaders/bidder.advertisers.headers';

export const BidderAdvertisers = observer(() => {
	const {
		bidderAdvertiserStore: { advertisersList },
	} = useStores<IAdminxStore>();
	const { currentRouteWithoutSpecialChars } = useRoute();
	const sortBy = usePageSettings().tableStore?.getSortingBy();
	const stateBetweenPages = useStateBetweenPages(() => advertisersList.getList().length !== 0);

	useList<BidderAdvertiserTableModel>(advertisersList, undefined, stateBetweenPages);

	const { columns } = useBidderAdvertisersHeaders();
	const { SelectedActions, FiltersActions } = useBidderAdvertiserActions();
	const sortedAdvertisers = sortData(advertisersList.getList().slice(), sortBy?.[0]);
	return (
		<Page>
			<Pagebar>
				<PagebarTitle>Advertisers</PagebarTitle>
			</Pagebar>

			<ControlledTable
				currentRoute={currentRouteWithoutSpecialChars}
				createRoute={routes.bidderAdvertisers.createAdvertiser()}
				columns={columns}
				data={sortedAdvertisers}
				defaultSortBy={sortBy}
				isLoading={advertisersList.getIsLoading()}>
				{() => {
					return {
						SelectedActions,
						FiltersActions,
					};
				}}
			</ControlledTable>
		</Page>
	);
});
